let loadPromise = null;

const isGoogleMapsPlacesReady = () => (
  typeof window !== 'undefined'
  && window.google
  && window.google.maps
  && window.google.maps.places
);

/**
 * Lazy-load the Google Maps JavaScript API with the Places library.
 * Used only by legacy PlacesAutocomplete UI — not loaded on login or other pages.
 */
export const loadGoogleMapsPlaces = () => {
  if (isGoogleMapsPlacesReady()) {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const apiKey = __CONFIG__.googleApiKey;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (isGoogleMapsPlacesReady()) {
        resolve();
        return;
      }
      reject(new Error('Google Maps Places library failed to initialize'));
    };
    script.onerror = () => reject(new Error('Failed to load Google Maps Places'));
    document.head.appendChild(script);
  });

  return loadPromise;
};

export default loadGoogleMapsPlaces;
